import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../lib/cn';
/**
 * **The empty box is a card, not a hole in the page** — TW 44164976, TW 44159943.
 *
 * The fill was `bg-muted/20`: `--ivory-300` at a fifth of its opacity, over a page that is
 * `--ivory-200`. Two steps of ivory apart at 20% is no difference at all on a screen, so every
 * "there is nothing here yet" box in three consoles read as a dashed outline around the page
 * itself rather than as a card waiting to be filled. Brad reported it twice in one day, on the
 * matches block and on the attending block of the same screen.
 *
 * `bg-card` is what the design draws: `background:var(--surface-card); border:1px dashed
 * var(--border-default); border-radius:var(--radius-lg)` — the one empty box in `Web App.dc.html`,
 * and the shape Your Events already hand-draws twice beside its two lists.
 *
 * The padding stays `px-6 py-12` rather than the prototype's `26px`. That box is an inline note
 * under a short list; these stand in for a grid of cards and want the height, which is what the
 * matches and attending blocks are already sized at and what Brad's screenshots show as correct
 * apart from the fill.
 */
export function EmptyState({ icon, title, description, action, className, }) {
    return (_jsxs("div", { className: cn('flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed bg-card px-6 py-12 text-center', className), children: [icon !== undefined ? _jsx("div", { className: "text-muted-foreground", children: icon }) : null, _jsxs("div", { className: "space-y-1", children: [_jsx("h3", { className: "text-base font-medium", children: title }), description !== undefined ? (_jsx("p", { className: "mx-auto max-w-sm text-sm text-muted-foreground", children: description })) : null] }), action !== undefined ? _jsx("div", { className: "pt-1", children: action }) : null] }));
}
//# sourceMappingURL=empty-state.js.map